import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncMaterialIconOutlined = createAsyncIcon(() => import('./MaterialIconOutlined'));

export default AsyncMaterialIconOutlined;

AsyncMaterialIconOutlined.displayName = 'AsyncMaterialIconOutlined';
